import React from "react";

interface PhotoDisplayProps {
  photoName: string;
  height: string;
  minWidth?: string;
  width: string
  fontSize?: string
}

export const PhotoDisplay: React.FC<PhotoDisplayProps> = ({ photoName, height="100px", minWidth="100px", width="100px", fontSize="40px" }) => {
    const containerStyle: React.CSSProperties = {
        height: height,
        minWidth: minWidth,
        width: width,
        fontSize: fontSize,
        backgroundColor: "var(--bg-hover-color)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      };

  return <span style={containerStyle}>{photoName}</span>;
};
